export default "__VITE_ASSET__Ca4z$eq0__"